import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "space-y-1" }
const _hoisted_5 = { class: "space-y-1" }
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = { class: "space-y-1" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center gap-1 p-2 border !border-b-0 !border-[#e5e5e5] rounded-t-md bg-white"
}
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_10 = { class: "space-y-1" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = { class: "pointer-events-none absolute inset-y-0 right-2 flex items-center" }
const _hoisted_13 = { class: "truncate" }
const _hoisted_14 = { class: "space-y-1" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "relative flex-grow" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = { class: "pointer-events-none absolute inset-y-0 right-2 flex items-center" }
const _hoisted_19 = { class: "space-y-1 md:col-span-2" }
const _hoisted_20 = { class: "space-y-3" }
const _hoisted_21 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "text-sm font-semibold" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "space-y-1" }
const _hoisted_26 = { class: "flex flex-col space-y-2" }
const _hoisted_27 = { class: "flex space-x-2" }
const _hoisted_28 = { class: "flex flex-wrap gap-2 mt-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "space-y-1" }
const _hoisted_31 = { class: "flex flex-col space-y-2" }
const _hoisted_32 = { class: "flex space-x-2" }
const _hoisted_33 = { class: "flex flex-wrap gap-2 mt-2" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "space-y-6" }
const _hoisted_36 = { class: "mb-6" }
const _hoisted_37 = { class: "flex items-center justify-center" }
const _hoisted_38 = { class: "flex bg-[#f5f5f5] rounded-lg p-1" }
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = { class: "flex items-center gap-2" }
const _hoisted_41 = { class: "min-h-[400px]" }
const _hoisted_42 = { class: "bg-[#f5f5f5] rounded-lg p-4 border border-[#e5e5e5]" }
const _hoisted_43 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_44 = { class: "relative" }
const _hoisted_45 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_46 = { class: "text-[#0a0a0a] font-medium" }
const _hoisted_47 = {
  key: 0,
  class: "text-xs text-[#737373] ml-auto"
}
const _hoisted_48 = {
  key: 1,
  class: "text-[#737373] italic flex items-center gap-2"
}
const _hoisted_49 = { class: "pointer-events-none absolute inset-y-0 right-2 flex items-center" }
const _hoisted_50 = { class: "flex items-center gap-2" }
const _hoisted_51 = { class: "font-medium text-[#0a0a0a]" }
const _hoisted_52 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_53 = {
  key: 0,
  class: "text-xs font-medium text-[#737373]"
}
const _hoisted_54 = {
  key: 1,
  class: "text-center py-6"
}
const _hoisted_55 = { class: "mb-4 flex items-center justify-center" }
const _hoisted_56 = { class: "flex h-12 w-12 items-center justify-center rounded-full bg-[#e5e5e580]" }
const _hoisted_57 = { class: "space-y-4" }
const _hoisted_58 = { class: "space-y-1" }
const _hoisted_59 = { class: "space-y-1" }
const _hoisted_60 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_61 = { class: "space-y-1" }
const _hoisted_62 = { class: "relative" }
const _hoisted_63 = { class: "space-y-1" }
const _hoisted_64 = { class: "relative" }
const _hoisted_65 = { class: "pointer-events-none absolute inset-y-0 right-2 flex items-center" }
const _hoisted_66 = { class: "truncate" }
const _hoisted_67 = { class: "space-y-1" }
const _hoisted_68 = { class: "space-y-6" }
const _hoisted_69 = { class: "bg-[#f5f5f5] p-4 rounded-md space-y-3" }
const _hoisted_70 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_71 = { class: "text-[#0a0a0a] capitalize" }
const _hoisted_72 = { class: "text-[#0a0a0a]" }
const _hoisted_73 = { class: "text-[#0a0a0a]" }
const _hoisted_74 = { class: "bg-[#f5f5f5] p-4 rounded-md space-y-3" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_77 = { class: "text-[#0a0a0a]" }
const _hoisted_78 = { class: "text-[#0a0a0a]" }
const _hoisted_79 = { class: "text-[#0a0a0a]" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { key: 2 }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "flex flex-wrap gap-2 mt-1" }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "flex flex-wrap gap-2 mt-1" }
const _hoisted_87 = {
  key: 0,
  class: "bg-[#f5f5f5] p-4 rounded-md space-y-3"
}
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_90 = { class: "text-[#0a0a0a]" }
const _hoisted_91 = { class: "text-[#0a0a0a]" }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_94 = { class: "text-[#0a0a0a]" }
const _hoisted_95 = { class: "text-[#0a0a0a] whitespace-pre-line" }
const _hoisted_96 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_97 = { class: "text-[#0a0a0a]" }
const _hoisted_98 = { class: "text-[#0a0a0a]" }
const _hoisted_99 = { class: "text-[#0a0a0a]" }

import { ref, type Ref, reactive, computed, watch, onMounted } from 'vue'
import { Briefcase, User, Plus, Bold, Italic, List, ChevronDown, FolderOpen, Search, Check } from 'lucide-vue-next'
import GoogleMap from '@/components/marketplace/generic/GoogleMap.vue'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { useTalentPoolsStore } from '@/stores/talentPoolsStore'
import { useProjectsStore } from '@/stores/projectsStore'
import { Button } from '@/components/marketplace/ui'
import { useEditor, EditorContent, type Editor } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import VueDatePicker from "@vuepic/vue-datepicker"
import "@vuepic/vue-datepicker/dist/main.css"; // import styles
import type { Project, NewProject } from '@/types/projects'
import type { TalentPool } from '@/types/talentPools'
import { useDropdownFloating } from '@/composables/useDropdownFloating'


type ProjectMode = 'existing' | 'new'
type TalentPoolType = 'general' | 'project' | null
type WorkType = typeof workTypes[number]['value']
type SalaryType = typeof salaryTypes[number]['value']
type HiringTimeline = typeof hiringTimelineOptions[number]['value'] | null
type ProjectDuration = typeof projectDurations[number]


interface Location {
  address: string
  lat: number | null
  lng: number | null
}

interface TalentPoolForm {
  type: TalentPoolType
  location: Location
  title: string
  description: string | null
  workType: WorkType
  salary: number | null
  salaryType: SalaryType
  hiringTimeline: HiringTimeline
  timeline: string | null
  requirements: string[]
  qualifications: string[]
  project: Project | NewProject | null
}

interface Step {
  id: number
  key: 'basicInfo' | 'jobDetails' | 'projectDetails' | 'review'
  label: string
}

// ==============================
// 2. Helpers
// ==============================

export default /*@__PURE__*/_defineComponent({
  __name: 'TalentPoolForm',
  props: {
    initialData: {},
    mode: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

// ==============================
// 1. Types
// ==============================
const workTypes = [
  { value: 'contract', label: 'Contract' },
  { value: 'permanent', label: 'Permanent' },
  { value: 'either', label: 'Either' }
] as const

const salaryTypes = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'daily', label: 'Daily' },
  { value: 'annually', label: 'Annually' }
] as const

const hiringTimelineOptions = [
  { value: 'immediate', label: 'Immediate' },
  { value: 'within_1_month', label: 'Within 1 month' },
  { value: 'ongoing', label: 'Casual Pool / Ongoing' },
  { value: 'months_1_3', label: '1 to 3 months' },
  { value: 'months_3_6', label: '3 to 6 months' },
  { value: 'specific_date', label: 'Specific date' }
] as const

const projectDurations = [
  '1-2 weeks',
  '1 month',
  '2-3 months',
  '3-6 months',
  '6-12 months',
  '12+ months'
] as const

const createEmptyProject = (): NewProject => ({
  name: '',
  summary: '',
  budget: null,
  startDate: null,
  length: projectDurations[0]
})

const createEmptyForm = (): TalentPoolForm => ({
  type: null,
  location: {
    address: '',
    lat: null,
    lng: null
  },
  title: '',
  description: null,
  workType: 'contract',
  salary: null,
  salaryType: 'annually',
  hiringTimeline: null,
  timeline: null,
  requirements: [],
  qualifications: [],
  project: null
})

const isLocationInvalid = ref(false)
const talentPoolsStore = useTalentPoolsStore();
const projectsStore = useProjectsStore();
const projectMode = ref<ProjectMode>('existing')
const selectedProject = ref<Project | null>(null)


// ==============================
// 3. State
// ==============================
const contentAreaRef = ref<HTMLElement | null>(null)
const poolRequirement = ref('')
const poolQualification = ref('')

const form = reactive<TalentPoolForm>(createEmptyForm())
const newProject = ref<NewProject>(createEmptyProject())

// keep project in sync with type
watch(() => form.type, (t) => {
  if (t === 'project' && !form.project) {
    form.project = createEmptyProject()
  }
  if (t !== 'project') {
    form.project = null
  }
})

const editor = useEditor({
  content: '', // We'll start with it empty
  extensions: [
    StarterKit,
  ],
  editorProps: {
    attributes: {
      class: 'min-h-[150px] resize-y overflow-auto w-full p-3 focus:outline-none !bg-[#e5e5e54d] text-[#0a0a0a] rounded-b-md',
    },
  },
})

watch(
  () => props.initialData,
  (data) => {
    if (!data) return

    // ==========================
    // 1. Map basic fields
    // ==========================
    Object.assign(form, {
      type: data.type ?? form.type,
      title: data.title ?? form.title,
      location: {
        address: data.location ?? form.location.address,
        lat: data.location_lat ?? form.location.lat,
        lng: data.location_lng ?? form.location.lng,
      },
      workType: data.workType ?? form.workType,
      salary: data.rate ?? form.salary,
      salaryType: data.rateType ?? form.salaryType,
      hiringTimeline: (data as any).hiring_timeline ?? (data.timeline ? 'specific_date' : form.hiringTimeline),
      timeline: data.timeline ?? (data as any).timeline_date ?? form.timeline, // timeline_date is aliased as timeline in API now
      requirements: data.requirements ?? form.requirements,
      qualifications: data.qualifications ?? form.qualifications,
    })

    // ==========================
    // 2. Prefill editor safely
    // ==========================
    if (data.description) {
      const setEditorContent = () => {
        if (!editor.value) return
        try {
          const parsed =
            typeof data.description === 'string'
              ? JSON.parse(data.description)
              : data.description
          editor.value.commands.setContent(parsed)
        } catch {
          editor.value.commands.setContent(data.description)
        }
      }

      if (editor.value?.isDestroyed === false) {
        setEditorContent()
      } else {
        const stop = watch(editor, (ed) => {
          if (ed) {
            setEditorContent()
            stop()
          }
        })
      }
    }

    // ==========================
    // 3. Prefill selected project
    // ==========================
    if (data.project_id) {
      const applyProject = () => {
        const match = projectsStore.projects.find(
          (p) => p.id === data.project_id
        )
        if (match) {
          selectedProject.value = match
          form.project = match
          form.type = 'project'
          projectMode.value = 'existing'
          return true
        }
        return false
      }

      // Try immediately; if not found, wait for projects to load
      if (!applyProject()) {
        const stop = watch(
          () => projectsStore.projects,
          (list) => {
            if (list.length && applyProject()) stop()
          },
          { immediate: true }
        )
      }
    } else {
      // No project linked — clear it
      selectedProject.value = null
      form.project = null
    }
  },
  { immediate: true }
)

const { reference: selectProjectButtonRef, floating: selectProjectOptionsRef, floatingStyles: selectProjectStyles } = useDropdownFloating('bottom-start')

const { reference: projectLengthButtonRef, floating: projectLengthOptionsRef, floatingStyles: projectLengthStyles } = useDropdownFloating('top')

// ==============================
// 4. Steps (wizard support)
// ==============================
const currentStepIndex = ref(0)

const steps = computed<Step[]>(() => {
  const baseSteps: Step[] = [
    { key: 'basicInfo', label: 'Talent Pool Info', id: 1 },
    { key: 'jobDetails', label: 'Role & Requirements', id: 2 },
    { key: 'review', label: 'Review & Submit', id: 3 }
  ]

  if (form.type === 'project') {
    baseSteps.splice(1, 0, { key: 'projectDetails', label: 'Project Details', id: 0 })
  }

  // reassign ids cleanly
  return baseSteps.map((step, index) => ({ ...step, id: index + 1 }))
})

const currentStep = computed<Step>(() => {
  return steps.value[currentStepIndex.value] ?? steps.value[0] // fallback safety
})

const handleLocationUpdate = (newCoords: { lat: number; lng: number }) => {
  form.location.lat = newCoords.lat
  form.location.lng = newCoords.lng
  isLocationInvalid.value = false
}

const handleGeocodeFail = () => {
  form.location.lat = null
  form.location.lng = null
  isLocationInvalid.value = true
}

const increaseStep = () => {
  if (currentStepIndex.value < steps.value.length - 1) {
    currentStepIndex.value++
  }
}

const decreaseStep = () => {
  if (currentStepIndex.value > 0) {
    currentStepIndex.value--
  }
}

// ==============================
// Form validation
// ==============================
// Step validators
// Step 1 - Basic Info
const validateBasicInfo = () => {
  return (
    form.title.trim().length > 0 &&
    form.location.address.trim().length > 0 &&
    form.type !== null &&
    !isLocationInvalid.value
  )
}

// Step 2 - Job Details
const validateJobDetails = () => {
  const isDescriptionValid =
    !!editor.value && editor.value.getText().trim().length > 0

  return (
    isDescriptionValid &&
    form.workType !== null &&
    form.salary !== null &&
    form.hiringTimeline !== null &&
    (form.hiringTimeline !== 'specific_date' || form.timeline !== null)
  )
}

// Step 3 - Project Details
const validateProjectDetails = () => {
  if (projectMode.value === 'existing') {
    return selectedProject.value !== null
  }

  return (
    newProject.value.name.trim().length > 0 &&
    newProject.value.summary.trim().length > 0 &&
    newProject.value.startDate !== null &&
    newProject.value.length !== null
  )
}
// Step 4 - REview
const validateReview = () => true

// Step validators map
const stepValidators: Record<string, () => boolean> = {
  basicInfo: validateBasicInfo,
  jobDetails: validateJobDetails,
  projectDetails: validateProjectDetails,
  review: validateReview,
}

// Computed property
const canProceedToNextStep = computed(() => {
  const validator = stepValidators[currentStep.value.key]
  return validator ? validator() : false
})

// ==============================
// Requirements and Qualifications
// ==============================

const addRequirement = () => {
  const value = poolRequirement.value.trim()
  if (!value) return
  if (!form.requirements.includes(value)) {
    form.requirements.push(value)
  }
  poolRequirement.value = ''
}

const addQualification = () => {
  const value = poolQualification.value.trim()
  if (!value) return
  if (!form.qualifications.includes(value)) {
    form.qualifications.push(value)
  }
  poolQualification.value = ''
}

///////////////////////////
///////////////////////////
///////////////////////////
///////////////////////////
///////////////////////////
///////////////////////////
//IMPORTANT FOR LATER WHEN I NEED TO RESET - use newProject.value = createEmptyProject()
///////////////////////////
///////////////////////////
///////////////////////////
///////////////////////////

__expose({
  currentStepIndex,
  currentStep,
  steps,
  canProceedToNextStep,
  increaseStep,
  decreaseStep,
  form,
  newProject,
  projectMode,
  selectedProject,
  editor
})

onMounted(() => {
  projectsStore.fetchProjects()
});

// Keep date cleared when a non-date option is chosen
watch(
  () => form.hiringTimeline,
  (val) => {
    if (val && val !== 'specific_date') {
      form.timeline = null
    }
  }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "contentAreaRef",
    ref: contentAreaRef,
    class: "p-6 flex-1 overflow-y-auto"
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[24] || (_cache[24] = _createElementVNode("label", {
          for: "poolType",
          class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none"
        }, [
          _createTextVNode(" Talent Pool Type "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["flex flex-col items-center justify-center gap-2 py-3 px-4 rounded-md border text-center bg-[#f5f5f5] text-[#737373] hover:bg-[#e5e5e5] focus:outline-none focus:ring-2 focus:ring-[#171717] transition-colors", form.type === 'general' ? 'bg-[#e5e5e5] border-[#171717] text-[#171717]' : '']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (form.type = 'general'))
          }, [
            _createVNode(_unref(User), {
              class: _normalizeClass(["h-6 w-6", form.type == 'general' ? 'text-[#171717]' : 'text-[#737373]'])
            }, null, 8, ["class"]),
            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm font-semibold" }, "General Pool", -1))
          ], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["flex flex-col items-center justify-center gap-2 py-3 px-4 rounded-md border text-center bg-[#f5f5f5] text-[#737373] hover:bg-[#e5e5e5] focus:outline-none focus:ring-2 focus:ring-[#171717] transition-colors", form.type === 'project' ? 'bg-[#e5e5e5] border-[#171717] text-[#171717]' : '']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (form.type = 'project'))
          }, [
            _createVNode(_unref(Briefcase), {
              class: _normalizeClass(["h-6 w-6", form.type == 'project' ? 'text-[#171717]' : 'text-[#737373]'])
            }, null, 8, ["class"]),
            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-sm font-semibold" }, "Project Pool", -1))
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[25] || (_cache[25] = _createElementVNode("label", {
          for: "poolLocation",
          class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none"
        }, [
          _createTextVNode(" Location "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.location.address) = $event)),
          type: "text",
          id: "poolLocation",
          name: "poolLocation",
          class: "w-full !bg-[#e5e5e54d] h-9 min-w-0 rounded-md text-[#0a0a0a] order px-3 py-1 placeholder:text-muted-foreground outline-none border !border-[#e5e5e5] md:text-sm"
        }, null, 512), [
          [_vModelText, form.location.address]
        ])
      ]),
      (form.location.address)
        ? (_openBlock(), _createBlock(GoogleMap, {
            key: 0,
            editable: "",
            address: form.location.address,
            "onUpdate:location": handleLocationUpdate,
            onGeocodeFailed: handleGeocodeFail
          }, null, 8, ["address"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _cache[26] || (_cache[26] = _createElementVNode("label", {
          for: "poolName",
          class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
        }, [
          _createTextVNode(" Talent Pool Name "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.title) = $event)),
          type: "text",
          id: "poolName",
          name: "poolName",
          class: "w-full !bg-[#e5e5e54d] h-9 min-w-0 rounded-md text-[#0a0a0a] order px-3 py-1 placeholder:text-muted-foreground outline-none border !border-[#e5e5e5] md:text-sm"
        }, null, 512), [
          [_vModelText, form.title]
        ])
      ])
    ], 512), [
      [_vShow, currentStep.value.key === 'basicInfo']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none" }, [
          _createTextVNode(" Job Details "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        (_unref(editor))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(editor).chain().focus().toggleBold().run())),
                class: _normalizeClass(["p-2 rounded hover:bg-gray-200", { 'bg-gray-200 text-gray-900': _unref(editor).isActive('bold') }]),
                title: "Bold"
              }, [
                _createVNode(_unref(Bold), { class: "h-4 w-4" })
              ], 2),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(editor).chain().focus().toggleItalic().run())),
                class: _normalizeClass(["p-2 rounded hover:bg-gray-200", { 'bg-gray-200 text-gray-900': _unref(editor).isActive('italic') }]),
                title: "Italic"
              }, [
                _createVNode(_unref(Italic), { class: "h-4 w-4" })
              ], 2),
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "w-px h-5 bg-gray-300 mx-1" }, null, -1)),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(editor).chain().focus().toggleBulletList().run())),
                class: _normalizeClass(["p-2 rounded hover:bg-gray-200", { 'bg-gray-200 text-gray-900': _unref(editor).isActive('bulletList') }]),
                title: "Bulleted List"
              }, [
                _createVNode(_unref(List), { class: "h-4 w-4" })
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(EditorContent), {
          editor: _unref(editor),
          class: "border border-border rounded-b-md min-h-[150px]"
        }, null, 8, ["editor"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[29] || (_cache[29] = _createElementVNode("label", { class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50" }, " Work type ", -1)),
          _createVNode(_unref(Listbox), {
            modelValue: form.workType,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.workType) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(ListboxButton), { class: "relative w-full cursor-default rounded-md border border-[#e5e5e5] bg-[#e5e5e54d] h-9 px-3 pr-8 text-left text-sm font-medium text-[#0a0a0a] focus:outline-none focus:ring-2 focus:ring-blue-500" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass([!form.workType ? 'text-gray-400 italic' : 'text-[#0a0a0a]', "block truncate"])
                    }, _toDisplayString(workTypes.find(w => w.value === form.workType)?.label), 3),
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_unref(ChevronDown), { class: "h-4 w-4 text-gray-500" })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, {
                  enter: "transition ease-out duration-100",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "transition ease-in duration-75",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ListboxOptions), { class: "absolute z-50 mt-1 w-full overflow-auto rounded-md border border-gray-200 bg-white text-sm shadow-lg focus:outline-none list-none p-0 m-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ListboxOption), {
                          disabled: "",
                          value: null,
                          class: "hidden"
                        }),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(workTypes, (workType) => {
                          return _createVNode(_unref(ListboxOption), {
                            key: workType.value,
                            value: workType.value,
                            class: "list-none"
                          }, {
                            default: _withCtx(({ selected, active }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex items-center justify-between cursor-pointer px-3 py-1.5 text-sm transition-colors", [
                      active ? 'bg-gray-100' : '',
                      selected ? 'font-semibold text-[#171717]' : 'font-normal text-gray-700'
                      ]]),
                                style: {"list-style":"none"}
                              }, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(workType.label), 1),
                                selected
                                  ? (_openBlock(), _createBlock(_unref(Check), {
                                      key: 0,
                                      class: "h-3.5 w-3.5 text-blue-600"
                                    }))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none" }, " Salary / Rate ", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "absolute inset-y-0 left-3 flex items-center text-gray-500" }, "$", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.salary) = $event)),
                type: "number",
                placeholder: "e.g., 90000",
                class: "w-full !bg-[#e5e5e54d] h-9 rounded-l-md rounded-r-none pl-8 pr-3 border !border-[#e5e5e5] focus:ring-2 focus:ring-blue-500 focus:z-10"
              }, null, 512), [
                [_vModelText, form.salary]
              ])
            ]),
            _createVNode(_unref(Listbox), {
              modelValue: form.salaryType,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.salaryType) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(ListboxButton), { class: "relative w-full cursor-default rounded-r-md border border-[#e5e5e5] bg-[#e5e5e54d] h-9 px-3 pr-8 text-left text-sm font-medium text-[#0a0a0a] focus:outline-none focus:ring-2 focus:ring-blue-500" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass([!form.workType ? 'text-gray-400 italic' : 'text-[#0a0a0a]', "block truncate"])
                      }, _toDisplayString(salaryTypes.find(w => w.value === form.salaryType)?.label), 3),
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_unref(ChevronDown), { class: "h-4 w-4 text-gray-500" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    enter: "transition ease-out duration-100",
                    "enter-from": "opacity-0 scale-95",
                    "enter-to": "opacity-100 scale-100",
                    leave: "transition ease-in duration-75",
                    "leave-from": "opacity-100 scale-100",
                    "leave-to": "opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ListboxOptions), { class: "absolute right-0 mt-1 w-28 rounded-md border border-[#e5e5e5] bg-white text-sm shadow-lg focus:outline-none z-10" }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(salaryTypes, (salaryType) => {
                            return _createVNode(_unref(ListboxOption), {
                              key: salaryType.value,
                              value: salaryType.value
                            }, {
                              default: _withCtx(({ selected, active }: { selected: boolean; active: boolean }) => [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["cursor-pointer select-none px-3 py-1.5", [
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        selected ? 'font-semibold' : 'font-normal'
                      ]])
                                }, _toDisplayString(salaryType.label), 3)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          }), 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[32] || (_cache[32] = _createElementVNode("label", {
            for: "hiringTimeline",
            class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none"
          }, " Hiring timeline ", -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(hiringTimelineOptions, (option) => {
                return _createElementVNode("button", {
                  key: option.value,
                  type: "button",
                  class: _normalizeClass(["w-full rounded-md border px-3 py-2 text-left transition-colors", form.hiringTimeline === option.value ? 'border-[#171717] bg-[#e5e5e5] text-[#171717]' : 'border-[#e5e5e5] bg-[#f5f5f5] text-[#0a0a0a]']),
                  onClick: ($event: any) => (form.hiringTimeline = option.value)
                }, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(option.label), 1)
                ], 10, _hoisted_22)
              }), 64))
            ]),
            (form.hiringTimeline === 'specific_date')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_unref(VueDatePicker), {
                    modelValue: form.timeline,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.timeline) = $event)),
                    "enable-time-picker": false,
                    "auto-apply": "",
                    teleport: "",
                    "min-date": new Date(),
                    placeholder: "Select hiring date",
                    "model-type": "yyyy-MM-dd",
                    "input-class": [
                'w-full h-9 rounded-md border border-[#e5e5e5] text-[#0a0a0a] px-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
                'bg-[#f5f5f5]'
                ],
                    "menu-class": ['rounded-lg shadow-lg border border-[#e5e5e5]', 'bg-[#f5f5e5]']
                  }, null, 8, ["modelValue", "min-date"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[34] || (_cache[34] = _createElementVNode("label", {
          for: "poolRequirments",
          class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
        }, " Pre-employment requirements ", -1)),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((poolRequirement).value = $event)),
              onKeyup: _withKeys(addRequirement, ["enter"]),
              type: "text",
              id: "poolRequirments",
              name: "poolRequirments",
              class: "w-full !bg-[#e5e5e54d] text-[#0a0a0a] h-9 min-w-0 rounded-md order px-3 py-1 placeholder:text-muted-foreground outline-none border !border-[#e5e5e5] md:text-sm",
              placeholder: "Add requirements"
            }, null, 544), [
              [_vModelText, poolRequirement.value]
            ]),
            _createVNode(_unref(Button), {
              onClick: addRequirement,
              class: "!bg-[#e5e5e54d]",
              variant: 'outline'
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus), { class: "h-6 w-6 text-[#737373]" })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.requirements, (req, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                "data-slot": "badge",
                class: "inline-flex items-center justify-center rounded-md border border-transparent !bg-[#e5e5e54d] text-secondary-foreground text-xs font-medium w-fit whitespace-nowrap shrink-0 gap-1 px-3 py-1 pr-1 transition-[color,box-shadow] hover:bg-secondary/90 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] overflow-hidden"
              }, [
                _createTextVNode(_toDisplayString(req) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (form.requirements.splice(index, 1)),
                  class: "ml-2 hover:text-destructive flex items-center justify-center"
                }, _cache[33] || (_cache[33] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "h-3 w-3 pointer-events-none",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", { d: "M18 6 6 18" }),
                    _createElementVNode("path", { d: "m6 6 12 12" })
                  ], -1)
                ]), 8, _hoisted_29)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _cache[36] || (_cache[36] = _createElementVNode("label", {
          for: "poolRequirments",
          class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
        }, " Required Certifications & Qualifications ", -1)),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((poolQualification).value = $event)),
              onKeyup: _withKeys(addQualification, ["enter"]),
              type: "text",
              id: "poolQualifications",
              name: "poolQualifications",
              class: "w-full !bg-[#e5e5e54d] text-[#0a0a0a] h-9 min-w-0 rounded-md order px-3 py-1 placeholder:text-muted-foreground outline-none border !border-[#e5e5e5] md:text-sm",
              placeholder: "Add certifications or qualifications"
            }, null, 544), [
              [_vModelText, poolQualification.value]
            ]),
            _createVNode(_unref(Button), {
              onClick: addQualification,
              class: "!bg-[#e5e5e54d]",
              variant: 'outline'
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus), { class: "h-6 w-6 text-[#737373]" })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.qualifications, (req, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                "data-slot": "badge",
                class: "inline-flex items-center justify-center rounded-md border border-transparent !bg-[#e5e5e54d] text-secondary-foreground text-xs font-medium w-fit whitespace-nowrap shrink-0 gap-1 px-3 py-1 pr-1 transition-[color,box-shadow] hover:bg-secondary/90 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] overflow-hidden"
              }, [
                _createTextVNode(_toDisplayString(req) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (form.qualifications.splice(index, 1)),
                  class: "ml-2 hover:text-destructive flex items-center justify-center"
                }, _cache[35] || (_cache[35] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "h-3 w-3 pointer-events-none",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", { d: "M18 6 6 18" }),
                    _createElementVNode("path", { d: "m6 6 12 12" })
                  ], -1)
                ]), 8, _hoisted_34)
              ]))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, currentStep.value.key === 'jobDetails']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (projectMode.value = 'existing')),
              class: _normalizeClass([
                'px-4 py-2 rounded-md text-sm font-medium transition-all duration-200',
                projectMode.value === 'existing' 
                  ? 'bg-[#171717] text-white shadow-sm' 
                  : 'text-[#737373] hover:text-[#171717]'
              ])
            }, [
              _createElementVNode("span", _hoisted_39, [
                _createVNode(_unref(FolderOpen), { class: "h-4 w-4" }),
                _cache[37] || (_cache[37] = _createTextVNode(" Existing Project "))
              ])
            ], 2),
            _createElementVNode("button", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (projectMode.value = 'new')),
              class: _normalizeClass([
                'px-4 py-2 rounded-md text-sm font-medium transition-all duration-200',
                projectMode.value === 'new' 
                  ? 'bg-[#171717] text-white shadow-sm' 
                  : 'text-[#737373] hover:text-[#171717]'
              ])
            }, [
              _createElementVNode("span", _hoisted_40, [
                _createVNode(_unref(Plus), { class: "h-4 w-4" }),
                _cache[38] || (_cache[38] = _createTextVNode(" New Project "))
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _withDirectives(_createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_unref(FolderOpen), { class: "h-5 w-5 text-[#737373]" }),
            _cache[39] || (_cache[39] = _createElementVNode("div", null, [
              _createElementVNode("h3", { class: "font-semibold text-[#171717]" }, "Select Existing Project"),
              _createElementVNode("p", { class: "text-sm text-[#737373]" }, "Choose from your active projects")
            ], -1))
          ]),
          (_unref(projectsStore).projects.length > 0)
            ? (_openBlock(), _createBlock(_unref(Listbox), {
                key: 0,
                modelValue: selectedProject.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedProject).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_unref(ListboxButton), {
                      ref_key: "selectProjectButtonRef",
                      ref: selectProjectButtonRef,
                      class: "relative w-full cursor-default rounded-md border border-[#e5e5e5] bg-[#e5e5e54d] h-9 px-3 pr-8 text-left text-sm font-medium text-[#0a0a0a] focus:outline-none focus:ring-2 focus:ring-[#171717]"
                    }, {
                      default: _withCtx(() => [
                        (selectedProject.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(selectedProject.value.name), 1),
                              (selectedProject.value.budget !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, "$" + _toDisplayString(selectedProject.value.budget?.toLocaleString()), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_48, [
                              _createVNode(_unref(Search), { class: "h-4 w-4" }),
                              _cache[40] || (_cache[40] = _createTextVNode(" Search and select a project... "))
                            ])),
                        _createElementVNode("span", _hoisted_49, [
                          _createVNode(_unref(ChevronDown), { class: "h-4 w-4 text-[#737373]" })
                        ])
                      ]),
                      _: 1
                    }, 512),
                    _createVNode(_Transition, {
                      enter: "transition ease-out duration-100",
                      "enter-from": "opacity-0 scale-95",
                      "enter-to": "opacity-100 scale-100",
                      leave: "transition ease-in duration-75",
                      "leave-from": "opacity-100 scale-100",
                      "leave-to": "opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ListboxOptions), {
                          ref_key: "selectProjectOptionsRef",
                          ref: selectProjectOptionsRef,
                          style: _normalizeStyle(_unref(selectProjectStyles)),
                          class: "absolute z-[100] mt-1 overflow-auto rounded-md border border-[#e5e5e5] bg-white text-sm shadow-lg focus:outline-none list-none p-0 m-0 max-h-72"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectsStore).projects, (project) => {
                              return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                key: project.id,
                                value: project,
                                class: "list-none"
                              }, {
                                default: _withCtx(({ selected, active }) => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass([
                        'flex items-center justify-between cursor-pointer px-3 py-2 text-sm transition-colors',
                        active ? 'bg-[#f5f5f5]' : '',
                        selected ? 'font-semibold text-[#171717] bg-[#e5e5e5]' : 'font-normal text-[#737373]'
                      ]),
                                    style: {"list-style":"none"}
                                  }, [
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, _toDisplayString(project.name), 1)
                                    ]),
                                    (project.budget)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          (project.budget !== null)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, "$" + _toDisplayString(project.budget?.toLocaleString()), 1))
                                            : _createCommentVNode("", true),
                                          selected
                                            ? (_openBlock(), _createBlock(_unref(Check), {
                                                key: 1,
                                                class: "h-3.5 w-3.5 text-[#171717]"
                                              }))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_unref(FolderOpen), { class: "h-6 w-6 text-[#737373]" })
                  ])
                ]),
                _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "font-semibold text-[#171717] mb-1" }, "No Projects Found", -1)),
                _cache[43] || (_cache[43] = _createElementVNode("p", { class: "text-sm text-[#737373] mb-4 max-w-[200px] mx-auto" }, " You don't have any projects to select from. ", -1)),
                _createVNode(_unref(Button), {
                  variant: 'outline',
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (projectMode.value = 'new')),
                  class: "w-full sm:w-auto"
                }, {
                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      class: "h-4 w-4 mr-2"
                    }, [
                      _createElementVNode("path", { d: "M5 12h14" }),
                      _createElementVNode("path", { d: "M12 5v14" })
                    ], -1),
                    _createTextVNode(" Create a New Project ")
                  ])),
                  _: 1
                })
              ]))
        ], 512), [
          [_vShow, projectMode.value === 'existing']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "flex items-center gap-2 text-sm font-semibold text-[#0a0a0a]" }, [
              _createTextVNode(" Project Name "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newProject.value.name) = $event)),
              type: "text",
              class: "w-full !bg-[#e5e5e54d] h-9 min-w-0 rounded-md text-[#0a0a0a] px-3 py-1 placeholder:text-muted-foreground outline-none border !border-[#e5e5e5] md:text-sm"
            }, null, 512), [
              [_vModelText, newProject.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "flex items-center gap-2 text-sm font-semibold text-[#0a0a0a]" }, [
              _createTextVNode(" Project Summary "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newProject.value.summary) = $event)),
              rows: "3",
              class: "resize-none !border-[#e5e5e5] text-[#0a0a0a] placeholder:text-muted-foreground !bg-[#e5e5e54d] flex w-full rounded-md border px-3 py-2 text-base outline-none md:text-sm"
            }, null, 512), [
              [_vModelText, newProject.value.summary]
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none" }, " Budget ", -1)),
              _createElementVNode("div", _hoisted_62, [
                _cache[46] || (_cache[46] = _createElementVNode("span", { class: "absolute inset-y-0 left-3 flex items-center text-gray-500" }, "$", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newProject.value.budget) = $event)),
                  type: "number",
                  min: "0",
                  step: "1000",
                  class: "w-full !bg-[#e5e5e54d] h-9 rounded-md pl-8 pr-3 border !border-[#e5e5e5] focus:ring-2 focus:ring-blue-500 focus:z-10"
                }, null, 512), [
                  [
                    _vModelText,
                    newProject.value.budget,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _cache[48] || (_cache[48] = _createElementVNode("label", { class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50" }, [
                _createTextVNode(" Expected Project Length "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _createVNode(_unref(Listbox), {
                modelValue: newProject.value.length,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((newProject.value.length) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_unref(ListboxButton), {
                      ref_key: "projectLengthButtonRef",
                      ref: projectLengthButtonRef,
                      class: "relative w-full cursor-default rounded-md border border-[#e5e5e5] bg-[#e5e5e54d] h-9 px-3 pr-8 text-left text-sm font-medium text-[#0a0a0a] focus:outline-none focus:ring-2 focus:ring-blue-500"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass([!newProject.value.length ? 'text-gray-400 italic' : 'text-[#0a0a0a]', "block truncate"])
                        }, _toDisplayString(newProject.value.length ?? 'Select length'), 3),
                        _createElementVNode("span", _hoisted_65, [
                          _createVNode(_unref(ChevronDown), { class: "h-4 w-4 text-gray-500" })
                        ])
                      ]),
                      _: 1
                    }, 512),
                    _createVNode(_Transition, {
                      enter: "transition ease-out duration-100",
                      "enter-from": "opacity-0 scale-95",
                      "enter-to": "opacity-100 scale-100",
                      leave: "transition ease-in duration-75",
                      "leave-from": "opacity-100 scale-100",
                      "leave-to": "opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ListboxOptions), {
                          ref_key: "projectLengthOptionsRef",
                          ref: projectLengthOptionsRef,
                          style: _normalizeStyle(_unref(projectLengthStyles)),
                          class: "absolute z-50 mt-1 w-full overflow-auto rounded-md border border-gray-200 bg-white text-sm shadow-lg focus:outline-none list-none p-0 m-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ListboxOption), {
                              disabled: "",
                              value: null,
                              class: "hidden"
                            }),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projectDurations, (value) => {
                              return _createVNode(_unref(ListboxOption), {
                                key: value,
                                value: value,
                                class: "list-none"
                              }, {
                                default: _withCtx(({ selected, active }) => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["flex items-center justify-between cursor-pointer px-3 py-1.5 text-sm transition-colors", [
                            active ? 'bg-gray-100' : '',
                            selected ? 'font-semibold text-[#171717]' : 'font-normal text-gray-700'
                          ]]),
                                    style: {"list-style":"none"}
                                  }, [
                                    _createElementVNode("span", _hoisted_66, _toDisplayString(value), 1),
                                    selected
                                      ? (_openBlock(), _createBlock(_unref(Check), {
                                          key: 0,
                                          class: "h-3.5 w-3.5 text-blue-600"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _cache[49] || (_cache[49] = _createElementVNode("label", {
              for: "hiringTimeline",
              class: "flex items-center gap-2 leading-none text-[#0a0a0a] text-sm font-semibold select-none"
            }, [
              _createTextVNode(" Expected Start Date "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _createVNode(_unref(VueDatePicker), {
              modelValue: newProject.value.startDate,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((newProject.value.startDate) = $event)),
              "enable-time-picker": false,
              "auto-apply": "",
              teleport: "",
              "min-date": new Date(),
              placeholder: "Select start date",
              "model-type": "yyyy-MM-dd",
              "input-class": [
              'w-full h-9 rounded-md border border-[#e5e5e5] text-[#0a0a0a] px-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
              'bg-[#f5f5f5]'
              ],
              "menu-class": ['rounded-lg shadow-lg border border-[#e5e5e5]', 'bg-[#f5f5e5]']
            }, null, 8, ["modelValue", "min-date"])
          ])
        ], 512), [
          [_vShow, projectMode.value === 'new']
        ])
      ])
    ], 512), [
      [_vShow, currentStep.value.key === 'projectDetails']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_68, [
      _createElementVNode("div", _hoisted_69, [
        _cache[53] || (_cache[53] = _createElementVNode("h4", { class: "font-semibold text-[#171717]" }, "Basic Information", -1)),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", null, [
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Talent Pool Type", -1)),
            _createElementVNode("div", _hoisted_71, _toDisplayString(form.type || '—'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Role Title", -1)),
            _createElementVNode("div", _hoisted_72, _toDisplayString(form.title || '—'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[52] || (_cache[52] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Location", -1)),
            _createElementVNode("div", _hoisted_73, _toDisplayString(form.location?.address || '—'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _cache[60] || (_cache[60] = _createElementVNode("h4", { class: "font-semibold text-[#171717]" }, "Role & Requirements", -1)),
        _createElementVNode("div", null, [
          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Role Description", -1)),
          _createElementVNode("div", {
            class: "prose prose-sm max-w-none",
            innerHTML: _unref(editor)?.getHTML()
          }, null, 8, _hoisted_75)
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", null, [
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Work Type", -1)),
            _createElementVNode("div", _hoisted_77, _toDisplayString(form.workType || '—'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Salary / Rate", -1)),
            _createElementVNode("div", _hoisted_78, "$" + _toDisplayString(form.salary) + " / " + _toDisplayString(form.salaryType), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[57] || (_cache[57] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Hiring Timeline", -1)),
            _createElementVNode("div", _hoisted_79, [
              (form.hiringTimeline === 'specific_date' && form.timeline)
                ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(new Date(form.timeline).toLocaleDateString()), 1))
                : (form.hiringTimeline)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(hiringTimelineOptions.find(o => o.value === form.hiringTimeline)?.label), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_82, "—"))
            ])
          ])
        ]),
        (form.requirements.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _cache[58] || (_cache[58] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Pre-employment Requirements", -1)),
              _createElementVNode("ul", _hoisted_84, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.requirements, (req) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: req,
                    class: "px-2 py-1 bg-[#e5e5e5] rounded-full text-xs text-[#0a0a0a] font-medium"
                  }, _toDisplayString(req), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (form.qualifications.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
              _cache[59] || (_cache[59] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Certifications & Qualifications", -1)),
              _createElementVNode("ul", _hoisted_86, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.qualifications, (qual) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: qual,
                    class: "px-2 py-1 bg-[#e5e5e5] rounded-full text-xs text-[#0a0a0a] font-medium"
                  }, _toDisplayString(qual), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (form.type === 'project')
        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
            _cache[69] || (_cache[69] = _createElementVNode("h4", { class: "font-semibold text-[#171717]" }, "Project Details", -1)),
            (projectMode.value === 'existing' && selectedProject.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", null, [
                      _cache[61] || (_cache[61] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Project Name", -1)),
                      _createElementVNode("div", _hoisted_90, _toDisplayString(selectedProject.value.name), 1)
                    ]),
                    _cache[62] || (_cache[62] = _createElementVNode("div", null, [
                      _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Location")
                    ], -1))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium mt-2" }, "Budget", -1)),
                    _createElementVNode("div", _hoisted_91, "$" + _toDisplayString(selectedProject.value.budget?.toLocaleString()), 1)
                  ])
                ]))
              : (projectMode.value === 'new')
                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", null, [
                        _cache[64] || (_cache[64] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Project Name", -1)),
                        _createElementVNode("div", _hoisted_94, _toDisplayString(newProject.value.name || '—'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Project Summary", -1)),
                      _createElementVNode("div", _hoisted_95, _toDisplayString(newProject.value.summary || '—'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", null, [
                        _cache[66] || (_cache[66] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Budget", -1)),
                        _createElementVNode("div", _hoisted_97, _toDisplayString(newProject.value.budget ? '$' + newProject.value.budget.toLocaleString() : '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[67] || (_cache[67] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Expected Project Length", -1)),
                        _createElementVNode("div", _hoisted_98, _toDisplayString(newProject.value.length || '—'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[68] || (_cache[68] = _createElementVNode("div", { class: "text-xs text-[#737373] font-medium" }, "Expected Start Date", -1)),
                      _createElementVNode("div", _hoisted_99, _toDisplayString(newProject.value.startDate ? new Date(newProject.value.startDate).toLocaleDateString() : '—'), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, currentStep.value.key === 'review']
    ])
  ], 512))
}
}

})